import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { Loading } from '../../../components/Loading';
import { APP_BASENAME } from '../../../config';
import { AccountType } from '../../../shared/Constants';

const i18n = defineMessages({
  currentAccount: {
    id: 'accounts.type.currentAccount',
    defaultMessage: 'current account',
  },
  subAccount: {
    id: 'accounts.type.subAccount',
    defaultMessage: 'Created',
  },
  active: {
    id: 'accounts.type.active',
    defaultMessage: 'Active',
  },
});

function getNodeHeaderClasses(node) {
  const base = 'node-header';
  if (node.isSubAccount) {
    return `${base} p-subaccount`;
  }

  if (node.isRoot) {
    return `${base} p-root`;
  }

  switch (node.accountType) {
    case AccountType.MCP:
      return `${base} p-mcp`;
    case AccountType.CP:
      return `${base} p-cp`;
    case AccountType.CLIENT:
      return `${base} p-client`;

    default:
      return base;
  }
}

function GetNodeSubtitle(props) {
  const { node } = props;
  const { formatMessage } = useIntl();
  // eslint-disable-next-line no-nested-ternary
  return node.isRoot
    ? formatMessage(i18n.currentAccount)
    : (node.isSubAccount ? formatMessage(i18n.subAccount) : formatMessage(i18n.active));
}

const NodeTemplate = node => (
  node ? (
    <div>
      <div className={getNodeHeaderClasses(node)}>
        {node.accountType}
        <br />
        <small><GetNodeSubtitle node={node} /></small>
      </div>
      <div className="node-content">
        <img
          alt={node.brandLogo ? node.brandLogo : 'default logo'}
          src={node.brandLogo ? node.brandLogo : `${APP_BASENAME}/images/default-logo.png`}
        />
        <div>
          <strong>
            {node.brandDisplayName}
          </strong>
        </div>
      </div>
    </div>
  ) : <Loading />
);

export default NodeTemplate;
